import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Navigation } from '@app/navigation/enums/navigation.enum';
import { TelecomSuccessContainer } from '@app/tots/containers/telecom-success/telecom-success.container';
import { TelecomStep } from '@app/tots/tots-wizard.constants';
import { TelecomInterestContainer } from './containers/telecom-interest/telecom-interest.container';
import { TelecomQualificationContainer } from './containers/telecom-qualification/telecom-qualification.container';

const routes: Routes = [
    {
        path: Navigation.TelecomInterested,
        component: TelecomInterestContainer,
    },
    {
        path: Navigation.TelecomQualification,
        component: TelecomQualificationContainer,
    },
    {
        path: TelecomStep.Success,
        component: TelecomSuccessContainer,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class TotsRoutingModule {}
